module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Kitchen2-3de3a716856d010581395d622648c6e2.jpg";